import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/dateUtils";

const PendingPayrollTable = ({
    className,
    data = [],
    loading = false,
    currentPage,
    pageSize,
    totalRecords,
    onPageChange,
}) => {
    const navigate = useNavigate();

    const totalPages = Math.ceil(totalRecords / pageSize);

    const formatCurrency = (value) => {
        if (!value || value === 0) return "N/A";
        return `$ ${Number(value).toLocaleString("en-US")}`;
    };

    const items = Array.isArray(data) ? data : data.items || [];

    const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

    const handleViewPay = (item) => {
        navigate("/selectedpayroll", {
            state: {
                clientId: item.clientId,
                clientName: item.clientName,
                companies: [
                    {
                        companyId: item.companyId,
                        companyName: item.companyName
                    }
                ],
                payrollFrom: item.payrollFrom,
                payrollTo: item.payrollTo
            }
        });
    };


    return (
        <>
            <div className={`custom_table table-responsive ${className || ""}`}>
                {/* TABLE */}
                <div className="table-wrapper">
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th>Client</th>
                                <th>Company</th>
                                <th>Payroll Period</th>
                                <th>Employees</th>
                                <th>Total Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        <div className="d-flex justify-content-center align-items-center py-4">
                                            <div className="spinner-border text-primary me-2" role="status">
                                                <span className="visually-hidden">Loading</span>
                                            </div>
                                            Loading
                                        </div>
                                    </td>
                                </tr>
                            ) : items.length > 0 ? (
                                items.map((item) => {
                                    const status = item.status === "Calculated" || item.status === "Recalculated" ? "Pending" : "Paid";
                                    return <tr key={item.payrollHeaderId}>
                                        <td>
                                            <div className="d-flex align-items-center gap_10">
                                                <div className="user_img me-2">
                                                    <img
                                                        src={BASE_URL + item.clientProfile}
                                                        alt="logo"
                                                        className="client_logo"
                                                    />
                                                </div>
                                                {item.clientName}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center gap_10">
                                                <div className="user_img me-2">
                                                    <img
                                                        src={BASE_URL + item.companyLogo}
                                                        alt="logo"
                                                        className="company_logo"
                                                    />
                                                </div>
                                                {item.companyName}
                                            </div>
                                        </td>

                                        <td>
                                            {formatDate(item.payrollFrom)} to {" "}
                                            {formatDate(item.payrollTo)}
                                        </td>

                                        <td>{item.employeeCount}</td>

                                        <td>{formatCurrency(item.totalAmount)}</td>

                                        <td>
                                            <span className="status-badge-blue medium">
                                                {status}
                                            </span>
                                        </td>

                                        <td>
                                            <button
                                                className="btn_outline_primary_light"
                                                onClick={() => handleViewPay(item)}
                                            >
                                                View / Pay
                                            </button>
                                        </td>
                                    </tr>;
                                })
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        No pending payroll payments.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION FOOTER */}
                {totalRecords > 0 && (
                    <div className="table_footer">
                        <div className="footer_left">
                            Showing {(currentPage - 1) * pageSize + 1}–
                            {Math.min(currentPage * pageSize, totalRecords)} of{" "}
                            {totalRecords} entries
                        </div>

                        <div className="footer_right">
                            <button
                                className="page_btn"
                                disabled={currentPage === 1}
                                onClick={() => onPageChange(currentPage - 1)}
                            >
                                ‹ Previous
                            </button>

                            {Array.from({ length: totalPages }, (_, i) => {
                                return <button
                                    key={i}
                                    className={`page_btn ${currentPage === i + 1 ? "active" : ""
                                        }`}
                                    onClick={() => onPageChange(i + 1)}
                                >
                                    {String(i + 1).padStart(2, "0")}
                                </button>;
                            })}

                            <button
                                className="page_btn"
                                disabled={currentPage === totalPages}
                                onClick={() => onPageChange(currentPage + 1)}
                            >
                                Next ›
                            </button>
                        </div>
                    </div>
                )}
            </div >
        </>
    );
};

export default PendingPayrollTable;
